module.exports = __webpack_public_path__ + "static/telecommunication.143cd7ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/industries/img/telecommunication.jpg
// module id = 563
// module chunks = 245523097761474